// extracted by mini-css-extract-plugin
module.exports = {"page":"JudgeList_page__MLBx0","mainTable":"JudgeList_mainTable__1eOTi"};